export { default } from './tag'
